import type { TripType } from "../use-flight-search-form";
import type { Route, useForm } from "../../use-form";

const hasRoundTripErrors = (route: Route) =>
  !route.origin ||
  !route.destination ||
  !route.departureDate ||
  !route.returnDate;

const hasOneWayErrors = (route: Route) =>
  !route.origin || !route.destination || !route.departureDate;

export const flightSearchFormHasErrors = ({
  formList,
  tripType,
}: {
  formList: ReturnType<typeof useForm>;
  tripType: TripType;
}) => {
  switch (tripType) {
    case "round-trip": {
      return hasRoundTripErrors(formList.first);
    }
    case "one-way": {
      return hasOneWayErrors(formList.first);
    }
    case "multi-city": {
      return formList.routes.some((route) => hasOneWayErrors(route));
    }
    default: {
      return false;
    }
  }
};
